import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./Galeria.css";

import foto1 from "../assets/quinta.webp";
import foto2 from "../assets/sexta.webp";

const imagenes = [foto1, foto2];

export default function Galeria() {
  return (
    <section className="galeria" data-aos="fade-up">
      <div className="galeria-contenedor">
        <Swiper
          modules={[Autoplay, Pagination]}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          loop={true}
          spaceBetween={20}
          slidesPerView={1} // siempre 1 para mostrar imagen completa
          className="galeria-swiper"
        >
          {imagenes.map((src, index) => (
            <SwiperSlide key={index}>
              <img src={src} alt={`Foto ${index + 1}`} className="foto-galeria" />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
